import { render, staticRenderFns } from "./PositionInformation.vue?vue&type=template&id=e6810542&scoped=true&"
import script from "./PositionInformation.vue?vue&type=script&lang=js&"
export * from "./PositionInformation.vue?vue&type=script&lang=js&"
import style0 from "./PositionInformation.vue?vue&type=style&index=0&id=e6810542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6810542",
  null
  
)

export default component.exports